import {AbstractControl } from '@angular/forms';


export const CustomInvalid = (control: AbstractControl): any => {

  const error = {
    invalidInvalid: true,
    message: 'This value is invalid'
  }
  
  return error;

};


// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/invalid/invalid.validator.ts